  import { withRouter } from 'react-router-dom';
  import WithSystem from './../service/WithSystem';
  const certificateFilter = JSON.parse(window.certificaterelease);
  class CerReleasedDropDown extends React.Component {
    constructor(props) {
      super(props);
      this.box = React.createRef();
      this.state = { dropdownToggle: false }
    }
    setCertificateItems = (selectedId, event) => {
      let certificate = this.props.queryFilter.certificate;
      certificate = certificate ? certificate.split(',') : [];
      if (event.target.checked) {
        certificate = certificate.length ? [...certificate, selectedId] : [selectedId];
      } else {
        certificate = certificate.filter((branch) => {
          return (branch != selectedId);
        });
      }
      certificate = certificate.length ? certificate.join() : false;
      this.props.setGlobalState({ certificate });
    }
    SetDropdownToggleVall = () => {
      this.setState({ dropdownToggle: !this.state.dropdownToggle }, () => {
        document.addEventListener('click', this.handleOutsideClick);
      });
    }
    handleOutsideClick = (event) => {
      if (this.box && !this.box.current.contains(event.target)) {
        this.setState({ dropdownToggle: !this.state.dropdownToggle }, () => {
          if (this.state.dropdownToggle == true) {
            this.setState({ dropdownToggle: false });
          }
          document.removeEventListener('click', this.handleOutsideClick);
        });
      }
    }
    
    render() {
      const CertificateItems = this.props.queryFilter['certificate'] ? this.props.queryFilter['certificate'].split(',') : [];
      return (
        <div ref={this.box} onClick={() => this.SetDropdownToggleVall()} className={this.state.dropdownToggle == true ? 'branch-list active' : 'branch-list'}>
          <span className="filter-subtxt">Certificate  Released</span>
          <div className="report-list-menu" >
            <div className="branch-list-sec">Certificate  Status</div>
            <div className="list_menu_section" >
              <ul className="list_menu">
              {certificateFilter.map((course) => {
                let hasChecked = CertificateItems.includes(course.id);
                return (
                  <li key={`cerreleased_${course.id}`}><label htmlFor={`cerreleased_${course.id}`}>
                   <span>
                      <input id={`cerreleased_${course.id}`} onClick={(e) => this.setCertificateItems(`${course.id}`, e)} className="bc_column_visible bc_initial_events uncheckbox" defaultChecked={hasChecked} data-column-name="Attendee Name" type="checkbox" data-field-name="attendee_name" />
                    <span className="checkedmark"></span>
                  </span>
                    <span className="dropdownlist_singleline">{course.name}</span></label></li>)
              })}
            </ul>
            </div>
          </div>
        </div>
      );
    }
  }
  export default withRouter(WithSystem(CerReleasedDropDown));
